/* unplugin-vue-components disabled */import script from "./BuyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BuyDialog.vue?vue&type=style&index=0&id=c4ed42f0&lang=less&scoped=true"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ed42f0"]])

export default __exports__